import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
  Card,
  CardBody,
  CardImage,
  CardTitle,
} from '@lanl-web/lanl-components';

import { getImageUrl, slugify } from '../../utils';

import './TeamCards.scss';

export const TeamCards = ({ className, teams }) => {
  const classes = classNames('team-cards', 'grid', className);

  return (
    <div className={classes}>
      {teams.map(({ name, link, team_image: { filename_disk } }) => (
        <Card key={`team-card-${slugify(name)}`}>
          <CardImage
            src={getImageUrl(filename_disk ?? '')}
            className='card-image'
            alt={`Team Card ${name}`}
          />
          <CardBody>
            <CardTitle>{`${name}`}</CardTitle>
            {/*<Link href={link} className='mt-auto'>*/}
            {/*  Read More*/}
            {/*  <span className='sr-only'>about the team: {name}</span>*/}
            {/*</Link>*/}
          </CardBody>
        </Card>
      ))}
    </div>
  );
};

TeamCards.defaultProps = {
  teams: [],
};

TeamCards.propTypes = {
  teams: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
};

export default TeamCards;
